import React from 'react';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import styles from './CourierListError.module.scss';
function CourierListError() {
  const { t } = useTranslation();

  return (
    <section className={styles.container}>
      <Typography variant="h1" className={styles.title}>
        {t('courierList.errorTitle', 'Sorry, there is an error')}
      </Typography>
      <Typography variant="body1" className={styles.description}>
        {t(
          'courierList.errorDescription',
          'It seems there is some issue in our backend, please try again later. Thank you.'
        )}
      </Typography>
    </section>
  );
}

export default CourierListError;
